$(function () {
    if ($('.errors').length) {
        $('html, body').animate({
            scrollTop: $("#kontakt-formular").offset().top - 120
        }, 600);
    }
})